import { ChangeDetectionStrategy, Component, EventEmitter, Injector, Output, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { TranslateService } from '@ngx-translate/core';
import { ChatModel } from '@src/models';
import { DialogConfirmComponent } from '@src/app/shared/dialogs';
import { ObjectId } from '@src/types/id';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'telegram-forward',
  templateUrl: './forward.component.html',
  styleUrls: ['./forward.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForwardComponent extends BaseResizableComponent {
  private readonly translateService = inject(TranslateService);
  private readonly dialogService = inject(TuiDialogService);
  private readonly injector = inject(Injector);

  @Output() chatSelected = new EventEmitter<{ selectedChat: ChatModel; message?: string }>();
  @Output() canceled = new EventEmitter<void>();

  messageText: string = '';
  selectedChatId: ObjectId;

  chatsFilter = {
    onlyUnionsChats: true,
  };

  private readonly confirmForwardDialog = this.dialogService.open<boolean>(
    new PolymorpheusComponent(DialogConfirmComponent, this.injector),
    {
      label: this.translateService.instant('components.forward.dialogs.forwardMessageHeader'),
      size: 's',
      closeable: false,
      dismissible: false,
    },
  );

  onClickReturnButton() {
    this.canceled.emit();
  }

  forwardToChat(selectedChat: ChatModel) {
    this.selectedChatId = selectedChat.id;
    this.confirmForwardDialog.pipe(takeUntil(this.destroyed$$)).subscribe({
      next: res => {
        if (res) {
          const message: string = this.messageText;
          this.chatSelected.emit({ selectedChat, message });
        } else {
          this.selectedChatId = undefined;
        }
      },
    });
  }
}
